import { laboratorioAccionesRoles } from '../../acciones-roles/departamentos/laboratio-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

export const LaboratorioRoutes: SideBarButton = {
  data: {
    name: 'Laboratorio',
    appendUrl: './compounding',
    roles: [...laboratorioAccionesRoles.sideNavActions.laboratorio],
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Agregar Pruebas',
        url: '/laboratory-data',
        roles: [...laboratorioAccionesRoles.sideNavActions.laboratoryData],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Registrar',
        url: '/laboratory-test',
        roles: [...laboratorioAccionesRoles.sideNavActions.laboratoryTest],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Reporte Testometric',
        overWriteUrl: './reportsPBI/laboratory/testometric',
      },
      options: PreConfigButton3,
    },
  ],
};
